module.exports = __webpack_public_path__ + "static/img/lock.87e51260.png";